// @ts-nocheck
import { Box, Stack, Typography } from "@mui/material";
import mainImg from "../../images/home.jpg";
import Product from "./Product";
import pro1 from "../../images/products/1.png";
import pro2 from "../../images/products/2.png";
import pro3 from "../../images/products/3.png";
import pro4 from "../../images/products/4.png";
import pro5 from "../../images/products/5.png";
import pro6 from "../../images/products/6.png";
import shortid from "shortid";
import Input from "../header/Input";

export default function Home() {
  return (
    <Box sx={{ bgcolor:"#eee"}}>
      <Typography
        variant="body2"
        sx={{ width: "100%", display: { xs: "block", sm: "block" } 
        ,
        height:{xs:"230px" , md:"100%"}
      }}
      >
        <img src={mainImg} style={{ width: "100%" , height:"100%" }} />
      </Typography>
      <Input />
      <Stack
        flexDirection={{ sm: "row", sx: "column" }}
        justifyContent={"space-around"}
        gap={3}
        sx={{ mt: { xs: 3, md: 0 }}}
        alignItems={"center"}
      >
        <Product
                  title={"Razer Kraken Tournament Edition THX 7.1 Surround Sound Gaming Headset: Retractable Noise Cancelling Mic - USB DAC -  For PC, PS4, PS5, Nintendo Switch, Xbox One, Xbox Series X & S, Mobile – Black"}
                  price={349.99}
                  img={pro1} rate={4} id={shortid.generate()}        />
        <Product
                  title={"Lenovo - 2021 - IdeaPad 3 - Gaming Laptop - AMD Ryzen 5 5600H - 8GB RAM - 256GB Storage - NVIDIA GeForce GTX 1650-15.6 FHD Display - Windows 11 Home"}
                  price={457}
                  img={pro2} rate={2} id={shortid.generate()}        />
      </Stack>

      <Stack
        flexDirection={{ sm: "row", sx: "column" }}
        justifyContent={"space-between"}
        mt={3}
        gap={3}
        mb={3}
        alignItems={"center"}
      >
        <Product
                  title={"Fujitsu ScanSnap iX1600 Wireless or USB High-Speed Cloud Enabled Document, Photo & Receipt Scanner with Large Touchscreen and Auto Document Feeder for Mac or PC, White"}
                  price={220}
                  img={pro3} rate={3} id={shortid.generate()}        />
        <Product
                  title={"Meta Quest 2 — Advanced All-In-One Virtual Reality Headset — 128 GB"}
                  price={105}
                  img={pro4} rate={5} id={shortid.generate()}        />
        <Product
                  title={"MeLE PCG02 Fanless Mini PC Stick Windows 11 Pro J4125 8GB/128GB Portable Mini Desktop Computer Stick Business & Home Video Support HDMI 4K 60Hz, BT4.2, 2.4G/5.8G Dual Band Wi-Fi, USB, Ethernet..."}
                  price={680}
                  img={pro5} rate={1} id={shortid.generate()}        />
      </Stack>

      <Product
              title={"SAMSUNG Galaxy S22 Ultra Cell Phone, Factory Unlocked Android Smartphone, 128GB, 8K Camera & Video, Brightest Display Screen, S Pen, Long Battery Life, Fast 4nm Processor, US Version, Phantom Black"}
              price={890}
              img={pro6} rate={4} id={shortid.generate()}      />
    </Box>
  );
}
